import { DashoardComponent } from '../../Components/DashoardComponent';
import { DashboardSolid } from '../../Components/DashboardSolid';
import { useContext } from 'react';
import { ThemeContext } from '../../context/theme-context';
import { Container } from 'react-bootstrap';

/**
 * Com REACT_APP_DASHBOARD_API definida (URL do dashboard-service), a tela usa
 * a dashboard em SolidJS servida pelo microserviço. Sem ela, segue a versão
 * em React sobre a API principal — o caminho de volta, caso o serviço não
 * esteja no ar em algum ambiente.
 */
const DASHBOARD_API = process.env.REACT_APP_DASHBOARD_API;

export default function Dashboard() {
  const { collapsed } = useContext(ThemeContext);

  return (
    <Container
      className={collapsed ? "contenteLayoutCollapsed" : "contenteLayout"}
    >
      {DASHBOARD_API ? <DashboardSolid apiUrl={DASHBOARD_API} /> : <DashoardComponent />}
    </Container>
  );
}
